import { render, staticRenderFns } from "./ProjectRolePermissionTab.vue?vue&type=template&id=5a8a0392&scoped=true&"
import script from "./ProjectRolePermissionTab.vue?vue&type=script&lang=js&"
export * from "./ProjectRolePermissionTab.vue?vue&type=script&lang=js&"
import style0 from "./ProjectRolePermissionTab.vue?vue&type=style&index=0&id=5a8a0392&lang=scss&scoped=true&"
import style1 from "./ProjectRolePermissionTab.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8a0392",
  null
  
)

export default component.exports